// extracted by mini-css-extract-plugin
export default {"input_del":"CheckboxDelete_input_del__qgYSu","label_del":"CheckboxDelete_label_del__JFbMB"};